// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__9UWvQ","author":"Table_author__2PCY1","authorImage":"Table_authorImage__2gveD","unreadRow":"Table_unreadRow__2I9fJ"};